import React from 'react';

export const DvOtvirVText = () => {
  return (
    <p>
      Використовується як евакуаційний вихід, якщо веде на сходовий майданчик з виходом назовні безпосередньо або через
      вестибюль; у прохід або коридор з безпосереднім виходом назовні або на сходовий майданчик. <br /> Клацніть лівою
      кнопкою миші на значок і перетягніть на стіну внутрішню.
    </p>
  );
};
